// Change password; other devices are signed out, this one gets a fresh session.
import { useState, type FormEvent } from "react";
import { api, errorText } from "../api/client";
import { useUI } from "../app/context";
import { Modal } from "./Modal";

export function PasswordDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} onClose={onClose} id="password">
      <PasswordForm onClose={onClose} />
    </Modal>
  );
}

function PasswordForm({ onClose }: { onClose: () => void }) {
  const { showToast } = useUI();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api("/api/password", { method: "POST", body: { current, new: next } });
      onClose();
      showToast("Password changed.");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit}>
      <div className="dlg">
        <h2>Change password</h2>
        <p>Other devices will be signed out.</p>
        <label className="field">
          <span>Current password</span>
          <input type="password" id="pw-current" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />
        </label>
        <label className="field">
          <span>New password</span>
          <input type="password" id="pw-new" autoComplete="new-password" minLength={10} required value={next} onChange={(e) => setNext(e.target.value)} />
          <small>At least 10 characters.</small>
        </label>
        <div className="error" id="pw-error" role="alert">
          {error}
        </div>
      </div>
      <div className="foot">
        <button className="btn" type="button" onClick={onClose}>
          Cancel
        </button>
        <button className="btn primary" value="ok" disabled={busy}>
          Change password
        </button>
      </div>
    </form>
  );
}
